import { getJoinCommandBarButton } from './getJoinCommandBarButton';
import { logUsage } from 'owa-analytics';
import { ViewType } from 'owa-calendar-actions';
import { getAddToMyCalendarButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getAddToMyCalendarButton';
import { getCancelButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getCancelButton';
import { getDeleteButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getDeleteButton';
import { getEditButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getEditButton';
import { getMeetingResponseButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getMeetingResponseButton';
import { getRemoveButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getRemoveButton';
import { closeItemPeek } from 'owa-calendar-peek';
import CalendarTime from 'owa-calendar-types/lib/types/CalendarTime';
import { CalendarEvent } from 'owa-calendar-types';
import { FilterableMenuItem } from 'owa-filterable-menu';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import EventScope from 'owa-service/lib/contract/EventScope';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { lazyHasTravelBookendData } from 'owa-mobility-read-view';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { deleteTripText } from './getPeekCommandBarItems.locstring.json';

export default function getPeekCommandBarItems(
    item: CalendarEvent,
    actionSource: ViewType,
    onEditClicked: (eventScope: EventScope) => void,
    onDeleteClicked: (eventScope: EventScope) => void,
    onRespondClicked: (
        newResponseType: ResponseTypeType,
        eventScope: EventScope,
        sendMessage: boolean,
        notes: string
    ) => void,
    onDismiss: () => void,
    showInlineCommandBar?: boolean
): FilterableMenuItem[] {
    const onSendHandler = (
        eventScope: EventScope,
        responseText: string,
        proposedTime: CalendarTime,
        sendResponse: boolean,
        forwardees: AttendeeType[],
        timeOpen: number
    ) => {
        closeItemPeek();
        logUsage('respondToCalendarItem', { actionSource: actionSource, timeOpen: timeOpen });
    };

    let deleteButtonItem: FilterableMenuItem = getDeleteButton(
        item,
        actionSource,
        false /*isFullForm*/,
        false /*isInPopOutWindow*/,
        onDeleteClicked
    );
    if (isFeatureEnabled('cal-mf-mobility')) {
        const hasTravelBookendData = lazyHasTravelBookendData.tryImportForRender();
        if (hasTravelBookendData?.()) {
            deleteButtonItem.name = loc(deleteTripText);
        }
    }

    const items = [
        getAddToMyCalendarButton(item, actionSource),
        getEditButton(item, 'Peek_Edit', onEditClicked),
        ...getMeetingResponseButton(
            item,
            actionSource,
            onRespondClicked,
            undefined /* getProposeNewTimeButton */,
            undefined /* onMenuOpened */,
            onSendHandler
        ),
        deleteButtonItem,
        getRemoveButton(item, actionSource, onDismiss),
        getCancelButton(item, actionSource, onDismiss),
    ];

    if (showInlineCommandBar) {
        // show Join button first
        items.unshift(getJoinCommandBarButton(item, actionSource));
        // FUTURE: once Edit is supported, need to ensure that only two items max are displayed and the rest go to overflow button
    }
    return items;
}
